import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type ClientsMaintainerFilters, type FilterGroupState } from '../types';

const updateClientsMaintainerFiltersCase: CaseReducer<
  FilterGroupState,
  PayloadAction<Partial<ClientsMaintainerFilters>>
> = (state, action) => {
  state.clients = {
    ...state.clients,
    ...action.payload,
  };

  return state;
};

export { updateClientsMaintainerFiltersCase };
